/** @format */

import {
	Component,
	EventEmitter,
	Input,
	OnChanges,
	OnInit,
	Output,
	SimpleChanges,
	inject
} from '@angular/core';
import {
	HomefieldIconLibraryModule,
	HomefieldIconsLibraryService,
	homefieldIconPlMediaPlay
} from '@dsg-tech/homefield-angular-icons';
import { Review, ReviewMedia, ReviewSelectedMedia } from '@product-reviews/data-access';

import { CommonModule } from '@angular/common';
import { ReviewPlayButtonComponent } from '../review-play-button/review-play-button.component';

@Component({
	selector: 'product-reviews-review-thumbnails',
	templateUrl: './review-thumbnails.component.html',
	styleUrl: './review-thumbnails.component.scss',
	imports: [CommonModule, HomefieldIconLibraryModule, ReviewPlayButtonComponent]
})
export class ReviewThumbnailsComponent implements OnChanges, OnInit {
	homefieldIconsLibraryService = inject(HomefieldIconsLibraryService);

	@Input() mediaItem: Review;
	@Input() selected: string;
	@Output() mediaSelected = new EventEmitter<ReviewSelectedMedia>();
	medias: ReviewMedia[] = [];
	selectedMedia: ReviewSelectedMedia | null = null;

	constructor() {
		this.homefieldIconsLibraryService.registerIcons([homefieldIconPlMediaPlay]);
	}

	ngOnInit() {
		this.medias = this.mediaItem.Media;
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.mediaItem) {
			const mediaItem = changes.mediaItem.currentValue;
			this.medias = mediaItem.Media;
		}
	}

	selectMedia(media: ReviewSelectedMedia, imageId: number): void {
		this.selectedMedia = {
			...media,
			imageId
		};
		this.mediaSelected.emit(this.selectedMedia);
	}

	/*
	 * Track media changed
	 */
	trackByMedia(index: number, media: ReviewMedia): string {
		return index.toString() + media.id;
	}
}
